import { TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import { ENVIRONMENT_LABEL_KEY } from 'src/common/consts/platformConfigConsts';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';
import { ConditionOperators, ConditionString } from 'src/common/types/graphql.generated';

import { DashboardDataQueryVariables } from '../DashboardData.generated';

import { buildEnvironmentFilters } from './environmentFilterBuilder';
import { FilterVariables } from './types';

const buildUnitIdFilter = (filters?: IFilterOptions): ConditionString => {
	if (filters?.unitId && filters.unitId.length > 0 && filters.unitId[0]?.value) {
		const unitIdValue = String(filters.unitId[0].value);
		return { value: [unitIdValue] } as ConditionString;
	}
	return { value: [''] } as ConditionString;
};

export const buildFilterVariables = (
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): FilterVariables => {
	const variablesBuilder = new QueryVariablesBuilder<DashboardDataQueryVariables>();

	const environmentConfig = buildEnvironmentFilters(filters);

	if (filters) {
		const dynamicFilterOptions = omit(filters ?? {}, [
			'dateRange',
			'searchValue',
			ENVIRONMENT_LABEL_KEY
		]) as TFilterOptions;

		variablesBuilder.addTupleFilterParam(
			CUSTOM_FIELDS_FILTER_PARAM_KEY,
			dynamicFilterOptions,
			ConditionOperators.All
		);
	}

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof DashboardDataQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const builderVariables = variablesBuilder.getVariables();
	const unitIdFilter = buildUnitIdFilter(filters);

	const filterVariables: FilterVariables = {
		unitIdFilter
	};

	if (builderVariables.customFieldsFilter) {
		filterVariables.customFieldsFilter = builderVariables.customFieldsFilter;
	}
	if (builderVariables.customFieldsFilterExcludes) {
		filterVariables.customFieldsFilterExcludes = builderVariables.customFieldsFilterExcludes;
	}

	if (environmentConfig) {
		filterVariables.environmentCustomFieldsFilter = environmentConfig.customFieldsFilter;
		filterVariables.environmentsFilter = environmentConfig.environmentsFilter;
		filterVariables.environmentFilter = environmentConfig.scoreFilter;
	}

	return filterVariables;
};
